import React from 'react';
import Badge from '@components/common/Badge';

// A Contact-User assigned as Contract Owner / Contract Manager without the Contract Role (ADO-707)
const PendingContactUserBadge: React.FC = () => (
  <Badge
    variant="warning"
    title="Assigned as Contract Owner or Contract Manager without the Contract Role"
    dataTestId="pending-contact-user-badge"
  >
    Pending Contact User
  </Badge>
);

export default PendingContactUserBadge;
